import type { Action } from 'redux'
import { defaultGetParams as getParams } from '../../../signalr/helpers'
import type { InvokeDefinition } from '../../../signalr/types'
import { addVenues, venueFetchFail } from './actions'
import type { Venue } from './types'

export const fetchVenuesDefinition: InvokeDefinition<[], Venue[], Action> = {
  method: 'GetVenues',
  strategy: 'switch',
  getParams,
  mapResponse: addVenues,
  mapError: venueFetchFail
}
